import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { faCalendar, faDollarSign, faPercentage, faShoppingCart } from '@fortawesome/pro-regular-svg-icons';
import { useTranslation } from 'react-i18next';
import { Inset } from 'syf-component-library/ui/spacing';
import Stack from 'syf-component-library/ui/spacing/Stack';
import { ErrorBoundary } from 'syf-component-library/ui/templates';
import Viewport from 'syf-component-library/ui/templates/Viewport';
import useDeviceWidth from '../../../../hooks/use-device-width';
import useTriggerAnalyticsEvent from '../../../../hooks/use-trigger-analytics-event';
import { StyledBorder, StyledFlex } from '../../../../styles/common';
import { StyledTitle } from '../../../../styles/text';
import CompleteIllustration from '../../../common/illustrations/cancel-payment/complete';
import MobileActivityRow from '../../../common/mobile-activity-row';
import { StyledMobileRowShadow } from '../../../common/mobile-activity-row/subcomponents';
import TableList from '../../../common/table-list';
import TransactionDetail from '../../../common/transaction-detail';
import TransactionRow from '../../../common/transaction-row';
import SelectPayGenericError from '../generic-error';
import { StyledSubheading } from './subcomponents';
var SelectPayComplete = function (_a) {
    var selectedPromotion = _a.selectedPromotion, selectedTransaction = _a.selectedTransaction;
    var t = useTranslation().t;
    var isMobile = useDeviceWidth();
    useTriggerAnalyticsEvent('selectPay.complete');
    if (!selectedTransaction || !selectedPromotion) {
        return null;
    }
    var description = selectedTransaction.description, amount = selectedTransaction.amount;
    var annualPercentageRate = selectedPromotion.annualPercentageRate, termLength = selectedPromotion.termLength, monthlyPaymentAmount = selectedPromotion.monthlyPaymentAmount, estimatedInterestAmount = selectedPromotion.estimatedInterestAmount, estimatedTotalAmount = selectedPromotion.estimatedTotalAmount;
    var transactionDetailArray = [
        {
            detail: "$".concat(amount),
            heading: t('selectPay.completeTotalPurchaseAmountLabel'),
            icon: faDollarSign,
            title: 'completeTotalPurchaseAmountLabel'
        },
        {
            detail: "$".concat(monthlyPaymentAmount),
            heading: t('selectPay.completeMonthlyPaymentAmountLabel'),
            icon: faDollarSign,
            title: 'completeMonthlyPaymentAmountLabel'
        },
        {
            detail: "".concat(annualPercentageRate, "%"),
            heading: t('selectPay.installmentRateLabel'),
            icon: faPercentage,
            title: 'installmentRateLabel'
        },
        {
            detail: "$".concat(estimatedInterestAmount),
            heading: t('selectPay.estimatedInterestAmountLabel'),
            icon: faDollarSign,
            title: 'estimatedInterestAmountLabel'
        },
        {
            detail: "$".concat(estimatedTotalAmount),
            heading: t('selectPay.estimatedTotalAmountLabel'),
            icon: faDollarSign,
            title: 'estimatedTotalAmountLabel'
        },
        {
            detail: parseInt(termLength, 10).toString(),
            heading: t('selectPay.completeMonthlyPaymentsLabel'),
            icon: faCalendar,
            title: 'completeMonthlyPaymentsLabel'
        },
        {
            detail: description,
            heading: t('selectPay.completePurchaseDetailsLabel'),
            icon: faShoppingCart,
            title: 'completePurchaseDetailsLabel'
        }
    ];
    return (_jsxs(Inset, { all: "large", children: [_jsxs(StyledFlex, { direction: "column", alignItems: "center", children: [_jsx(Inset, { vertical: "xlarge", children: _jsx(CompleteIllustration, {}) }), _jsx(Stack, { size: "xlarge" }), _jsx(StyledTitle, { size: isMobile ? 'medium' : 'large', weight: "semiBold", align: "center", children: t('selectPay.completeHeading') }), _jsx(Stack, { size: "small" }), _jsx(StyledSubheading, { align: "center", children: t('selectPay.completeSubHeading') })] }), _jsx(Stack, { size: "xlarge" }), _jsx(StyledTitle, { size: "large", weight: "light", children: t('selectPay.completeTransactionHeading') }), _jsx(Stack, { size: "medium" }), _jsx(StyledBorder, {}), _jsx(Stack, { size: "large" }), _jsx(Viewport.Mobile, { children: _jsx(StyledMobileRowShadow, { children: _jsx(MobileActivityRow, { item: selectedTransaction, isolated: true }) }) }), _jsx(Viewport.Desktop, { children: _jsx(TableList, { children: _jsx(TransactionRow, { item: selectedTransaction, isolated: true }) }) }), _jsx(Stack, { size: "large" }), _jsxs(Inset, { vertical: "medium", children: [_jsx(StyledTitle, { size: "large", weight: "light", children: t('selectPay.completeDetailsHeading') }), _jsx(Stack, { size: "medium" }), _jsx(StyledBorder, {}), _jsx(Stack, { size: "medium" }), _jsx(ErrorBoundary, { fallback: _jsx(SelectPayGenericError, {}), children: _jsx("dl", { children: transactionDetailArray.map(function (_a) {
                                var detail = _a.detail, heading = _a.heading, icon = _a.icon, title = _a.title;
                                return (_jsx(TransactionDetail, { detail: detail, heading: heading, icon: icon, title: title, currentFlow: "selectPay" }, title));
                            }) }) }), _jsx(Inset, { top: "base", bottom: "base", children: _jsx(StyledBorder, {}) }), _jsx("p", { children: t('selectPay.completeFooterText') })] })] }));
};
export default SelectPayComplete;
//# sourceMappingURL=index.js.map